import React, { useState } from 'react';
import { BiArrowFromLeft, BiArrowFromRight } from 'react-icons/bi';
import { useDispatch } from 'react-redux';
import { checkMot } from '../../ressources/functionJS/checkMot';
import * as type_btn from '../../ressources/glossaires/glossaire_type_de_bouton';
import * as actions from '../../services/actions';
import * as indexConteneurInfo from '../../ressources/glossaires/glossaire_conteneur_info';
import ConteneurInformation from '../ConteneurInformation/ConteneurInformation';
import Bouton from '../UI/Bouton/Bouton';
import FormulaireVue from './ProfilVue/FormulaireVue/FormulaireVue';
import ProfilVue from './ProfilVue/ProfilVue';
import TableauVue from './TableauVue/TableauVue';
import styles from './Vue.module.scss';

const Vue = ({ reqModifier }) => {
  const [parametresSelectione, setParametresSelectione] = useState({});
  const [montrerInfo, setMontrerInfo] = useState(false);
  const [montrerInfoFull, setMontrerInfoFull] = useState(false);
  const [indexConteneurInfoState, setIndexConteneurInfo] = useState(null);

  const dispatch = useDispatch();

  const ligneSelectione = (info) => {
    setParametresSelectione(info);
    setIndexConteneurInfo(indexConteneurInfo.profil);
    setMontrerInfo(true);
  };

  const commutateurInfoCreer = () => {
    if (montrerInfo) {
      setMontrerInfoFull(false);
    }
    setMontrerInfo(!montrerInfo);
  };

  const commutateurInfoFull = () => {
    setMontrerInfoFull(!montrerInfoFull);
  };

  const commutateurAnnuler = () => {
    setMontrerInfo(false);
    setIndexConteneurInfo(null);
  };

  const creerVue = () => {
    setMontrerInfo(true);
    setIndexConteneurInfo(indexConteneurInfo.ajouterForm);
  };

  let styleConteneurCentralGauche = [styles.ConteneurCentralGauche];
  let styleConteneurCentralDroite = [styles.ConteneurCentralDroite];
  let commutateurClasses = [styles.CommutateurInfo];

  if (montrerInfo && montrerInfoFull) {
    styleConteneurCentralDroite.push(styles.ConteneurCentralDroiteFull);
    styleConteneurCentralGauche.push(styles.ConteneurCentraGaucheVoid);
  } else if (montrerInfo && !montrerInfoFull) {
    styleConteneurCentralDroite.push(styles.ConteneurCentralDroiteOuvert);
  } else {
    styleConteneurCentralDroite.push(styles.ConteneurCentralDroiteFermer);
    styleConteneurCentralGauche.push(styles.ConteneurCentraGaucheFermer);
  }

  return (
    <div className={styles.ConteneurVue}>
      <div className={styleConteneurCentralGauche.join(' ')}>
        <TableauVue projetSelectione={ligneSelectione} creer={creerVue} />
        <div className={styles.titleModule}>{checkMot('vues')}</div>
      </div>
      <div className={styleConteneurCentralDroite.join(' ')}>
        <Bouton
          ajoutClass={[commutateurClasses, styles.expandTO].join(' ')}
          cliquer={commutateurInfoCreer}
          rond={true}
          type={type_btn.danger}
        >
          <BiArrowFromLeft size={15} />
        </Bouton>
        <Bouton
          ajoutClass={styles.expand}
          cliquer={commutateurInfoFull}
          rond={true}
          type={type_btn.danger}
        >
          <BiArrowFromRight size={15} />
        </Bouton>
        <ConteneurInformation
          selectionInfo={indexConteneurInfoState}
          ajouterForm={
            <FormulaireVue
              ajouterAlerte={(typeAlerte, titre, corps) =>
                dispatch(actions.ajouterAlerte(typeAlerte, titre, corps))
              }
              annuler={commutateurAnnuler}
            />
          }
          profil={
            <ProfilVue
              infoVue={parametresSelectione}
              reqModifier={reqModifier}
              reqSupprimer={(idVue) => dispatch(actions.reqSupprimerVue(idVue))}
            />
          }
        />
      </div>
    </div>
  );
};

export default Vue;
